import {
  AsyncCallArgs,
  GridContainer,
  GridItem,
  handleFormSubmission,
  InputFormField,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
  ViewDialog,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import React from "react";
import useAppDispatch from "../../../../../../../../hooks/redux/base/useAppDispatch";
import { UserEmailDetails } from "../../../../../../../../types/userTypes";
import { changeUserEmailInitialValues } from "../../../../../../../../init/changeUserEmailInitialValues";
import { createBaseUserEmailValidationSchema } from "../../../../../../../../yup/schema/users/userValidationSchema";
import { changeEmail } from "../../../../../../../../axios/api/services";
import useAppSelector from "../../../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../../../store/redux/slice/ComponentsControl/myAccountControl";

const EmailChangeDialog = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const dispatch = useAppDispatch();

  const { methods } = useReactHookForm<UserEmailDetails>({
    defaultValues: changeUserEmailInitialValues,
    validationSchema: createBaseUserEmailValidationSchema,
  });

  const onSubmit = (values) => {
    const asyncEmailChange: AsyncCallArgs = {
      promise: changeEmail(values),
      reactHooksForm: { methods },
      onSuccess: () => {
        toast.success(t("m.user.send.change.email.success"));
        handleCloseDialog();
      },
    };
    asyncCall(asyncEmailChange);
  };

  const { open } = useAppSelector((state) => {
    return state.ComponentsControl.myAccountControl.modals.emailChange;
  });

  const handleCloseDialog = () => {
    methods.reset(changeUserEmailInitialValues);
    dispatch(closeModal({ modalType: "emailChange" }));
  };

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.change.email.dialog"}>
      <FormProvider {...methods}>
        <form onSubmit={handleFormSubmission({ methods, onSubmitFn: onSubmit, t })}>
          <GridContainer spacing={3}>
            <GridItem sm={12} md={12}>
              <InputFormField required={true} fieldName={"email"} labelCode={"l.person.email"} />
            </GridItem>
            <GridItem sm={12} md={12}>
              <Typography align={"right"}>
                <SubmitFormButton label={"l.btn.submit"} />
              </Typography>
            </GridItem>
          </GridContainer>
        </form>
      </FormProvider>
    </ViewDialog>
  );
};

export default EmailChangeDialog;
